<template>
    <table class="table table-responsive-sm">
        <tr>
            <th>Name</th>
            <th>Username</th>
            <th>Email</th>
        </tr>
        <tr v-for="user in users" :key="'user-row-'+user.id" class="user-row"
            @click="$emit('userRowClicked', user)">
            <td>{{ user.name }}</td>
            <td>{{ user.username }}</td>
            <td>{{ user.email }}</td>
        </tr>
        <tr v-if="!users.length" class="alert-warning">
            <td colspan="3">No matching users</td>
        </tr>

    </table>
</template>

<script>
    export default {
        name: "UserTable",
        props: {
            users: {type: Array, required: false}
        },
    }
</script>

<style scoped>
    .user-row {
        cursor: pointer;

    }

    .user-row:hover {
        background: gray
    }

</style>
